import React, { useState } from 'react';
import { ChevronDown, ChevronUp, MessageCircle, Mail, Phone } from 'lucide-react';
import Header from './Header';
import Footer from './Footer';

const FAQ = () => {
  const [openItem, setOpenItem] = useState(null);

  const faqData = [
    {
      id: 1,
      category: 'Ordini e Prodotti',
      questions: [
        {
          question: 'Come funziona il processo di personalizzazione?',
          answer: 'Il processo è molto semplice: scegli il tipo di liquore (Gin, Amaro o Bitter), seleziona gli ingredienti che preferisci, personalizza l\'etichetta e scegli il tipo di bottiglia. Il nostro mastro distillatore si occuperà di bilanciare la tua ricetta per garantire un risultato perfetto.'
        },
        {
          question: 'Quanto costa la spedizione?',
          answer: 'La spedizione è sempre gratuita senza minimo di ordine! Questo fa parte della nostra missione di garantire un\'esperienza utente unica.'
        },
        {
          question: 'Quanto tempo ci vuole per ricevere il mio ordine?',
          answer: 'Dopo che viene approvata la grafica, il tuo liquore personalizzato viene prodotto e imbottigliato in massimo 3 giorni lavorativi. Dopodiché viene immediatamente spedito. I tempi di consegna sono di 2-3 giorni lavorativi per l\'Italia.'
        },
        {
          question: 'Posso ordinare più bottiglie con la stessa ricetta?',
          answer: 'Assolutamente sì! Durante il processo di checkout puoi specificare la quantità desiderata. Offriamo anche sconti per ordini di grandi quantità per eventi speciali.'
        }
      ]
    },
    {
      id: 2,
      category: 'Personalizzazione e Ingredienti',
      questions: [
        {
          question: 'Quanti ingredienti posso selezionare?',
          answer: 'Puoi selezionare fino a 5 botaniche diverse per creare la tua ricetta unica. Ti consigliamo di sperimentare con combinazioni diverse - a volte gli abbinamenti più inaspettati danno risultati straordinari!'
        },
        {
          question: 'Gli ingredienti sono di alta qualità?',
          answer: 'Lacinio SRL utilizza esclusivamente materie prime certificate e di alta qualità. Tutti gli ingredienti vengono selezionati con cura dal nostro mastro distillatore per garantire il miglior sapore possibile.'
        },
        {
          question: 'Posso personalizzare completamente l\'etichetta?',
          answer: 'Hai tante possibilità: Puoi caricare una tua etichetta realizzato dal tuo grafico; Puoi inserire il testo che preferisci sull\'etichetta (fino a 50 caratteri) e scegliere il colore. Il design dell\'etichetta mantiene uno stile elegante e professionale che valorizza il tuo liquore personalizzato.'
        },
        {
          question: 'Che gradazione alcolica hanno i liquori?',
          answer: 'I nostri liquori hanno una gradazione alcolica dai 25% ai 40% vol, che è lo standard per liquori di alta qualità. Questa gradazione garantisce il perfetto equilibrio tra sapore e corpo del liquore.'
        }
      ]
    },
    {
      id: 3,
      category: 'Produzione e Qualità',
      questions: [
        {
          question: 'Dove vengono prodotti i liquori?',
          answer: 'Tutti i nostri liquori sono prodotti da Lacinio SRL presso il nostro stabilimento in Via G. Mercalli, 16 Z.I., 88900 Crotone (KR). Ogni bottiglia è realizzata artigianalmente con certificazioni di qualità seguendo tradizioni secolari.'
        },
        {
          question: 'Come garantite la qualità del prodotto finale?',
          answer: 'Lacinio SRL utilizza esclusivamente materie prime certificate italiane e ogni ricetta viene bilanciata dal nostro mastro distillatore esperto. Il processo produttivo avviene nel nostro stabilimento certificato a Crotone con controlli di qualità rigorosi.'
        },
        {
          question: 'Posso visitare il liquorificio?',
          answer: 'Certo! E\'possibile organizzare dei tour guidati in azienda. Per richiedere una visita basta compilare il form nella pagina contatti.'
        }
      ]
    },
    {
      id: 4,
      category: 'Regali e Occasioni Speciali',
      questions: [
    
        {
          question: 'Offrite buoni regalo?',
          answer: 'Sì, offriamo buoni regalo di diversi importi che permettono al destinatario di creare il proprio liquore personalizzato. È il regalo perfetto per chi ama sperimentare!'
        },
        {
          question: 'Posso ordinare liquori per matrimoni o eventi aziendali?',
          answer: 'Assolutamente sì! Lacinio SRL offre servizi dedicati per matrimoni, eventi aziendali e celebrazioni speciali. Contattaci al +39 393 9587340 o via email a preventivi@iltuoamaro.it per preventivi personalizzati e sconti per grandi quantità.'
        }
      ]
    },
    {
      id: 5,
      category: 'Assistenza e Resi',
      questions: [
        {
          question: 'Cosa succede se non sono soddisfatto del prodotto?',
          answer: 'La tua soddisfazione è la priorità di Lacinio SRL. Se non sei completamente soddisfatto del tuo liquore, contattaci al +39 393 9587340 o via email a info@iltuoamaro.it entro 30 giorni dalla consegna e troveremo insieme la soluzione migliore.'
        },
        {
          question: 'Come posso tracciare il mio ordine?',
          answer: 'Riceverai un\'email con il codice di tracciamento non appena il tuo ordine verrà spedito. Potrai seguire lo stato della spedizione in tempo reale.'
        },
        {
          question: 'Posso modificare o cancellare il mio ordine?',
          answer: 'Puoi modificare o cancellare il tuo ordine fino a quando non inizia la produzione (solitamente entro 2 ore dall\'ordine). Contatta Lacinio SRL al +39 393 9587340 o via email a info@iltuoamaro.it se hai bisogno di apportare modifiche.'
        }
      ]
    }
  ];

  const toggleItem = (categoryId, questionIndex) => {
    const itemId = `${categoryId}-${questionIndex}`;
    setOpenItem(openItem === itemId ? null : itemId);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-purple-600 to-pink-600 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4">
            Domande Frequenti
          </h1>
          <p className="text-xl max-w-3xl mx-auto">
            Trova le risposte alle domande più comuni sui nostri liquori personalizzati
          </p>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {faqData.map((category) => (
            <div key={category.id} className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-purple-600">
                {category.category}
              </h2>
              
              <div className="space-y-4">
                {category.questions.map((item, index) => {
                  const itemId = `${category.id}-${index}`;
                  const isOpen = openItem === itemId;
                  
                  return (
                    <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden">
                      <button
                        onClick={() => toggleItem(category.id, index)}
                        className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors duration-200"
                      >
                        <span className="text-lg font-semibold text-gray-900 pr-4">
                          {item.question}
                        </span>
                        {isOpen ? (
                          <ChevronUp className="w-5 h-5 text-purple-600 flex-shrink-0" />
                        ) : (
                          <ChevronDown className="w-5 h-5 text-purple-600 flex-shrink-0" />
                        )}
                      </button>
                      
                      {isOpen && (
                        <div className="px-6 pb-4">
                          <p className="text-gray-700 leading-relaxed">{item.answer}</p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Non hai trovato la risposta che cercavi?
          </h2>
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
            Il team di Lacinio SRL è sempre pronto ad aiutarti. Contattaci attraverso uno dei canali sottostanti.
          </p>
          
          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-purple-100 text-purple-600 rounded-full mb-4">
                <MessageCircle className="w-8 h-8" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Lacinio SRL</h3>
              <p className="text-gray-600 mb-4">Via G. Mercalli, 16 Z.I.<br />88900 Crotone (KR)</p>
              <p className="text-purple-600 font-medium">P.IVA: 03714460791</p>
            </div>
            
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-purple-100 text-purple-600 rounded-full mb-4">
                <Mail className="w-8 h-8" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Email</h3>
              <p className="text-gray-600 mb-4">Risposta entro 24 ore</p>
              <a href="mailto:info@iltuoamaro.it" className="text-purple-600 hover:text-purple-700 font-medium">
                info@iltuoamaro.it
              </a>
            </div>
            
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-purple-100 text-purple-600 rounded-full mb-4">
                <Phone className="w-8 h-8" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">WhatsApp</h3>
              <p className="text-gray-600 mb-4">Assistenza rapida via WhatsApp</p>
              <a href="https://wa.me/393939587340" className="text-purple-600 hover:text-purple-700 font-medium">
                +39 393 9587340
              </a>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default FAQ;